import { Languages } from 'lucide-react';
import { languageOptions, useI18n, type AppLanguage } from '../i18n';

type Props = {
  compact?: boolean;
};

const LanguageSwitcher: React.FC<Props> = ({ compact = false }) => {
  const { language, setLanguage, t } = useI18n();

  return (
    <label className={`flex items-center gap-2 rounded-full border border-white/50 bg-white/90 text-slate-700 shadow-sm ${compact ? 'px-2 py-1' : 'px-3 py-2'}`}>
      <Languages className="h-4 w-4 text-slate-500" />
      <span className="sr-only">{t('language.label')}</span>
      <select
        value={language}
        onChange={(event) => setLanguage(event.target.value as AppLanguage)}
        className="bg-transparent text-xs font-semibold outline-none"
        aria-label={t('language.label')}
      >
        {languageOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {compact ? option.shortLabel : option.label}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSwitcher;
